<div class="p-5 grid grid-cols-4 items-center gap-2" [formGroup]="priceScaleForm">
    <span class="label-text" i18n>Type</span>
    <div class="col-span-3 flex flex-col items-stretch gap-1">
        <select
            class="select select-sm select-bordered"
            formControlName="scaleType"
            [ngClass]="{ 'border-error': priceScaleForm.get('scaleType').invalid }"
        >
            <option [ngValue]="null">-</option>
            <option
                *ngFor="let scaleTypeOption of scaleTypeOptions()"
                [ngValue]="scaleTypeOption.value"
                [disabled]="!scaleTypeOption.selectable"
            >
                {{ scaleTypeOption.label }}
            </option>
        </select>
        <span class="text-xs text-error" *ngIf="priceScaleForm.get('scaleType').dirty && priceScaleForm.get('scaleType').invalid" i18n
            >A valid type is required.</span
        >
    </div>

    <div class="col-span-4 divider" i18n>Price intervals</div>

    <app-feedback-banner
        *ngIf="hasGaps()"
        class="col-span-4"
        variant="warning"
        [message]="gapWarning"
        [showCloseIcon]="false"
    ></app-feedback-banner>

    <div class="col-span-4 flex flex-row gap-4">
        <div class="flex-1 grid grid-cols-4 gap-2">
            <span class="label-text" i18n>Interval begin</span>
            <span class="label-text" i18n>Interval end</span>
            <span class="label-text" i18n>Monthly price</span>
            <span class="label-text" i18n>Yearly price</span>
        </div>
        <div class="w-10"></div>
    </div>

    <ng-container formArrayName="priceIntervals">
        <div class="col-span-4 flex flex-col items-stretch gap-2">
            <ng-container *ngFor="let intervalForm of priceIntervals.controls; let i = index">
                <div class="flex flex-row gap-4" [formGroup]="intervalForm">
                    <div class="flex-1 grid grid-cols-4 gap-2">
                        <div class="flex flex-col items-stretch gap-1">
                            <input
                                class="input input-sm input-bordered"
                                type="number"
                                formControlName="intervalBegin"
                                [ngClass]="{ 'border-error': intervalForm.get('intervalBegin').invalid }"
                            />
                            <ng-container *ngIf="intervalForm.get('intervalBegin').dirty">
                                <span class="text-xs text-error" *ngIf="intervalForm.get('intervalBegin').errors?.required" i18n
                                    >The Interval begin is required.</span
                                >
                                <span class="text-xs text-error" *ngIf="intervalForm.get('intervalBegin').errors?.min" i18n
                                    >The value must not be negative.</span
                                >
                                <span class="text-xs text-error" *ngIf="intervalForm.get('intervalBegin').errors?.notInteger" i18n
                                    >The value must be a whole number.</span
                                >
                            </ng-container>
                            <div *ngIf="intervalForm?.errors?.beginGreaterThanEnd">
                                <span class="text-error text-sm" i18n>The Interval begin must be smaller than the end</span>
                            </div>
                        </div>
                        <div class="flex flex-col items-stretch gap-1">
                            <input
                                class="input input-sm input-bordered"
                                type="number"
                                formControlName="intervalEnd"
                                [ngClass]="{ 'border-error': intervalForm.get('intervalEnd').invalid }"
                            />
                            <ng-container *ngIf="intervalForm.get('intervalEnd').dirty">
                                <span class="text-xs text-error" *ngIf="intervalForm.get('intervalEnd').errors?.required" i18n
                                    >The Interval end is required.</span
                                >
                                <span class="text-xs text-error" *ngIf="intervalForm.get('intervalEnd').errors?.min" i18n
                                    >The value must not be negative.</span
                                >
                                <span class="text-xs text-error" *ngIf="intervalForm.get('intervalEnd').errors?.notInteger" i18n
                                    >The value must be a whole number.</span
                                >
                            </ng-container>
                        </div>
                        <div class="flex flex-col items-stretch gap-1">
                            <label class="w-full input-group input-group-sm">
                                <input
                                    class="min-w-0 flex-1 input input-sm input-bordered"
                                    type="number"
                                    formControlName="priceMonthly"
                                    [ngClass]="{ 'border-error': intervalForm.get('priceMonthly').invalid }"
                                />
                                <span>€</span>
                            </label>
                            <ng-container *ngIf="intervalForm.get('priceMonthly').dirty">
                                <span class="text-xs text-error" *ngIf="intervalForm.get('priceMonthly').errors?.required" i18n
                                    >The monthly price is required.</span
                                >
                                <span class="text-xs text-error" *ngIf="intervalForm.get('priceMonthly').errors?.min" i18n
                                    >The value must not be negative.</span
                                >
                            </ng-container>
                        </div>
                        <div class="flex flex-col items-stretch gap-1">
                            <label class="w-full input-group input-group-sm">
                                <input
                                    class="min-w-0 flex-1 input input-sm input-bordered"
                                    type="number"
                                    formControlName="priceYearly"
                                    [ngClass]="{ 'border-error': intervalForm.get('priceYearly').invalid }"
                                />
                                <span>€</span>
                            </label>
                            <ng-container *ngIf="intervalForm.get('priceYearly').dirty">
                                <span class="text-xs text-error" *ngIf="intervalForm.get('priceYearly').errors?.required" i18n
                                    >The yearly price is required.</span
                                >
                                <span class="text-xs text-error" *ngIf="intervalForm.get('priceYearly').errors?.min" i18n
                                    >The value must not be negative.</span
                                >
                            </ng-container>
                        </div>
                    </div>
                    <div class="w-10">
                        <button
                            *ngIf="editMode()"
                            i18n-matTooltip
                            matTooltip="Remove interval"
                            matTooltipClass="bg-iota-tooltip-bg"
                            class="btn btn-ghost btn-circle btn-sm"
                            (click)="removeInterval(i)"
                        >
                            <iota-icon icon="trash"></iota-icon>
                        </button>
                    </div>
                </div>
            </ng-container>

            <div *ngIf="!priceIntervals?.controls?.length" class="text-center text-sm italic" i18n>No intervals defined.</div>

            <div *ngIf="priceIntervals?.errors?.priceIntervalsIntersect" class="text-center text-error" i18n>
                Some price intervals overlap each other with the begin/end values.
            </div>

            <div class="flex flex-row items-center justify-center">
                <button *ngIf="editMode()" class="btn btn-primary btn-sm" (click)="addInterval(undefined, true)" i18n>Add interval</button>
            </div>
        </div>
    </ng-container>
</div>
